import { createAsyncThunk } from "@reduxjs/toolkit";
import { logout } from "toolkit/profile/profile.slice";
import { snackWrapper } from "helpers";
import { authAPI } from "libs/apiClient/Auth";
import { userAPI } from "libs/apiClient/User";

export const login = createAsyncThunk(
	"profileSlice/login",
	async (
		{ email, password, memorization }: { email: string; password: string; memorization: boolean },
		{ rejectWithValue, dispatch },
	) => {
		try {
			// const profile = (
			//   await $api.post<IProfile>(`/auth/login?email=${email}&pw=${pw}`)
			// ).data;
			const profile = await authAPI.authCreate({ email, password }).then((r) => r.data);
			dispatch(getPermissions());
			// if (memorization) dispatch(memoryProfile());

			localStorage.setItem("token", profile.token!);
			if (memorization) localStorage.setItem("memorization", "true");
			return {
				profile,
				memorization,
			};
		} catch (e: any) {
			return rejectWithValue({
				message: "Неверные почта или пароль",
				status: e.response.status,
			});
		}
	},
);

export const signUp = createAsyncThunk(
	"profileSlice/signUp",
	async (
		{
			email,
			password,
			name,
			surname,
			patronymic,
		}: {
			email: string;
			password: string;
			name: string;
			surname: string;
			patronymic: string;
		},
		{ rejectWithValue },
	) => {
		try {
			const profile = await authAPI
				.registerCreate({
					firstName: name,
					middleName: patronymic,
					lastName: surname,
					email: email,
					password: password,
				})
				.then((r) => r.data);

			localStorage.setItem("memorization", "true");
			localStorage.setItem("token", profile.token!);
			// dispatch(memoryProfile());
			return profile;
		} catch (e: any) {
			return rejectWithValue({
				message: "Пользователь с таким email уже существует",
				status: e.response.status,
			});
		}
	},
);

export const loginByToken = createAsyncThunk(
	"profileSlice/loginByToken",
	async (token: string, { rejectWithValue, dispatch }) => {
		try {
			const res = authAPI.postAuth({ token }).then((r) => r.data);
			dispatch(getPermissions());

			return res;
		} catch (e) {
			dispatch(logout);
			return rejectWithValue(e);
		}
	},
);

export const getPermissions = createAsyncThunk("profileSlice/getPermissions", async (_, { rejectWithValue }) => {
	try {
		return await userAPI.permissionsAdminList().then((r) => r.data);
	} catch (e) {
		return rejectWithValue(e);
	}
});

export const verifyEmail = createAsyncThunk("profileSLice/verifyEmail/", async (email: string, { rejectWithValue }) => {
	try {
		console.log('submit')
		return await authAPI.verifyCreate({ email }).then((r) => r.data.success);
	} catch ({ message }) {
		return rejectWithValue(message);
	}
});

export const changePassword = createAsyncThunk(
	"profileSLice/changePassword/",
	async (body: { email: string; newPassword: string }, { rejectWithValue }) => {
		try {
			return await authAPI
				.updateCreate({
					email: body.email,
					password: body.newPassword,
				})
				.then((r) => r.data);
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);

export const resetPassword = createAsyncThunk(
	"profileSLice/resetPassword/",
	async (email: string, { rejectWithValue }) => {
		try {
			await userAPI.passwordResetCreate({ email }).then(() => snackWrapper("success", "Пароль успешно сброшен"));
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);

// export const loginWithToken = (token: string) => async (dispatch: Dispatch<profileActions>) => {
//   try {

//       const request = await fetch(`${serverURL}/auth/login?tk=${token}`, {
//           method: "POST"
//       });
//       let result: IProfile = await request.json()
//       if (!Object.keys(result).length) {
//           alert("Неверный логин или пароль");
//           return;
//       }
//       dispatch({ type: profileActionsTypes.LOGIN, payload: result })
//   } catch (e) {
//       // alert('Error:' + e);
//   }
// }
